import {Dropdown, Menu, Space} from "antd";
import React from "react";

export default ({text, actions, onClick}) => {
    let menu = <Menu>
      {actions.map(a => _.isArray(a) ? <Menu.Item key={a[0]} onClick={a[2] || (() => onClick(a[1]))}>{a[0]}</Menu.Item> : a)}
    </Menu>

  return <Dropdown trigger={['click']} overlay={menu}>
    <a onClick={e => e.preventDefault()}>
      <Space>
        {text}
      </Space>
    </a>
  </Dropdown>
}

